import { render, staticRenderFns } from "../routes/routes.html?vue&type=template&id=c5d0bd04&scoped=true&external"
import script from "../routes/routes.js?vue&type=script&lang=js&external"
export * from "../routes/routes.js?vue&type=script&lang=js&external"
import style0 from "../routes/routes.css?vue&type=style&index=0&id=c5d0bd04&prod&scoped=true&lang=css&external"
import style1 from "./Routes.vue?vue&type=style&index=1&id=c5d0bd04&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d0bd04",
  null
  
)

export default component.exports